(function ($) {
  'use strict';

  var $trigger = $('.tc-card__trigger');

  // For on scroll animations
  function animate_cards(thisTrigger) {
    thisTrigger.parents('.tc-card--interactive').addClass('active');
    thisTrigger.children().find('.card__content-inner').attr("aria-expanded", "true");
    thisTrigger.children().find('.card__label').attr("aria-hidden", "true");

    // make the other ones inactive
    thisTrigger.parents().siblings('.tc-card--interactive').removeClass('active');
    thisTrigger.parents().siblings('.tc-card--interactive').children().find('.card__content-inner').attr("aria-expanded", "false");
    thisTrigger.parents().siblings('.tc-card--interactive').children().find('.card__label').attr("aria-hidden", "false");
  }

  // On click run function
  $trigger.on('click', function() {
    animate_cards($(this));
  });

  // Keyboard controls
  $trigger.keypress(function() {
    // Enter key or Spacebar run function
    if (event.which == 13 || event.which == 32) animate_cards($(this));
  });

  $(window).on("load resize", function(e){
    // find the width of the active card
    var cardWidth = $('.tc-card--interactive.active').find('.card__content-inner').width();
    // apply the width to the other cards
    if ($(window).width() >= 639) {
      $('.tc-card--interactive').each(function(){
        $(this).find('.card__content-inner').width(cardWidth);
      });
    }
  });

})(jQuery);
